import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";

import { Footer } from "../../components/Footer/Footer";
import { useSelections } from "../../context/Selections";

const OBJECTS_IDS = {
  INVES_PBP: "EyN",
  QUARTER: "hDJWWa",
};

function Investigation({ app, config }) {
  const { selections } = useSelections();
  const [quater, setQuater] = useState("");

  const getQuater = useCallback(
    async (objectId) => {
      if (app && objectId) {
        try {
          const res = await app.visualization.get(objectId);
          const value = res?.model?.layout?.style?.label;
          setQuater(value);
        } catch (error) {
          console.error("Erro ao buscar nome do usuário:", error);
        }
      }
    },
    [app]
  );

  useEffect(() => {
    if (app) {
      getQuater(OBJECTS_IDS.QUARTER);
    }
  }, [selections, app, getQuater]);

  return (
    <div className="app investigation">
      <div className="appContent">
        <LayoutWrapper>
          <Grid>
            <Card className="container-card-only-title">
              <h1 className="title">Apuração PBP</h1>
              <p className="subtitle">Período analisado: {quater}</p>
            </Card>
          </Grid>

          <Grid container className="container-apuração">
            <Card
              app={app}
              header={{
                hardTitle: "Apuração",
              }}
              exportContainer
              exportTable
              exportTableId={OBJECTS_IDS.INVES_PBP}
              style={{ margin: "16px 0" }}
              expandable
            >
              <NativeObject
                app={app}
                key={OBJECTS_IDS.INVES_PBP}
                reference={{ id: OBJECTS_IDS.INVES_PBP }}
                style={{
                  width: "100%",
                  height: "370px",
                }}
              />
            </Card>
          </Grid>

          <Footer app={app} />
        </LayoutWrapper>
      </div>
    </div>
  );
}

Investigation.defaultProps = {
  app: null,
  config: {},
};

Investigation.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default Investigation;
